<template>
  <div>
    <h5
      v-if="isCreation"
      align="center"
    >
      Add New Session
    </h5>
    <h5
      v-else
      align="center"
    >
      Update Session
    </h5>
    <div
      class="flex flex-center"
      padding
    >
      <q-form
        ref="validateForm"
        @submit="onValidate"
        class="q-my-md"
        greedy
      >
        <div
          class="q-gutter-md"
          style="width: 650px; max-width: 250px"
        >
          <fieldset class="q-gutter-md">
            <legend class="text-left text-h5">
              Name and Dates
            </legend>
            <q-separator />
            <div class="q-gutter-md row items-start">
              <q-input
                v-model.trim="sessionDetails.sessionName"
                label="Session Name *"
                style="width: 300px"
                :rules="[checkInput, checkSessionNameDuplicates]"
                lazy-rules
                :borderless="isRa"
                :readonly="isRa"
              />
              <q-select
                v-model.trim="sessionDetails.sessionType"
                :options="sessionTypeList"
                label="Session Type *"
                style="width: 300px"
                :rules="[checkSelect]"
                lazy-rules
                :borderless="isRa"
                :readonly="isRa"
                :hide-dropdown-icon="isRa"
              />
            </div>
            <div class="q-gutter-md row items-start">

              <q-input
                label="Session Start Date *"
                style="width: 300px"
                v-model="sessionDetails.startDate"
                :rules="[checkDate]"
                lazy-rules
                :borderless="isRa"
                :readonly="isRa"
              >
                <template
                  v-if="!isRa"
                  v-slot:append
                >
                  <q-icon
                    name="event"
                    class="cursor-pointer"
                  >
                    <q-popup-proxy
                      ref="qDateProxy"
                      transition-show="scale"
                      transition-hide="scale"
                    >
                      <q-date
                        v-model="sessionDetails.startDate"
                        mask="MM/DD/YYYY"
                      >
                        <div class="row items-center justify-end">
                          <q-btn
                            v-close-popup
                            label="Close"
                            color="primary"
                            flat
                          />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
              <q-input
                label="Session End Date *"
                style="width: 300px"
                v-model="sessionDetails.endDate"
                lazy-rules
                :rules="[checkDate, val => checkDateAGreaterThanB(
                  sessionDetails.endDate, sessionDetails.startDate)
                || 'End date must come after start date']"
                :borderless="isRa"
                :readonly="isRa"
              >
                <template
                  v-if="!isRa"
                  v-slot:append
                >
                  <q-icon
                    name="event"
                    class="cursor-pointer"
                  >
                    <q-popup-proxy
                      ref="qDateProxy"
                      transition-show="scale"
                      transition-hide="scale"
                    >
                      <q-date
                        v-model="sessionDetails.endDate"
                        mask="MM/DD/YYYY"
                      >
                        <div class="row items-center justify-end">
                          <q-btn
                            v-close-popup
                            label="Close"
                            color="primary"
                            flat
                          />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </div>

            <div class="q-gutter-md row items-start">
              <q-input
                label="Move In Date *"
                style="width: 300px"
                v-model="sessionDetails.moveInDate"
                lazy-rules
                :rules="[checkDate, val => checkDateIsBetween(
                  sessionDetails.moveInDate, sessionDetails.startDate, sessionDetails.endDate)
                || 'Move in date must be between start date and end date']"
                :borderless="isRa"
                :readonly="isRa"
              >
                <template
                  v-if="!isRa"
                  v-slot:append
                >
                  <q-icon
                    name="event"
                    class="cursor-pointer"
                  >
                    <q-popup-proxy
                      ref="qDateProxy"
                      transition-show="scale"
                      transition-hide="scale"
                    >
                      <q-date
                        v-model="sessionDetails.moveInDate"
                        mask="MM/DD/YYYY"
                      >
                        <div class="row items-center justify-end">
                          <q-btn
                            v-close-popup
                            label="Close"
                            color="primary"
                            flat
                          />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
              <q-input
                label="Move Out Date *"
                style="width: 300px"
                v-model="sessionDetails.moveOutDate"
                :rules="[checkDate,
                                        val => checkDateIsBetween(
                sessionDetails.moveOutDate,
                sessionDetails.moveInDate,
                sessionDetails.endDate
                                        )
                || 'Move out date must be between move in date and end date']"
                lazy-rules
                :borderless="isRa"
                :readonly="isRa"
              >
                <template
                  v-if="!isRa"
                  v-slot:append
                >
                  <q-icon
                    name="event"
                    class="cursor-pointer"
                  >
                    <q-popup-proxy
                      ref="qDateProxy"
                      transition-show="scale"
                      transition-hide="scale"
                    >
                      <q-date
                        v-model="sessionDetails.moveOutDate"
                        mask="MM/DD/YYYY"
                      >
                        <div class="row items-center justify-end">
                          <q-btn
                            v-close-popup
                            label="Close"
                            color="primary"
                            flat
                          />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </div>
            <div class="q-gutter-md row items-start">
              <q-input
                label="Application Deadline *"
                style="width: 300px"
                v-model="sessionDetails.applicationDeadline"
                :rules="[checkDate,
                                        val => checkDateIsBetween(
                sessionDetails.applicationDeadline,
                sessionDetails.startDate,
                sessionDetails.moveInDate
                                        )
                || 'Application deadline must be between start date and move in date']"
                lazy-rules
                :borderless="isRa"
                :readonly="isRa"
              >
                <template
                  v-if="!isRa"
                  v-slot:append
                >
                  <q-icon
                    name="event"
                    class="cursor-pointer"
                  >
                    <q-popup-proxy
                      ref="qDateProxy"
                      transition-show="scale"
                      transition-hide="scale"
                    >
                      <q-date
                        v-model="sessionDetails.applicationDeadline"
                        mask="MM/DD/YYYY"
                      >
                        <div class="row items-center justify-end">
                          <q-btn
                            v-close-popup
                            label="Close"
                            color="primary"
                            flat
                          />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
              <q-input
                label="Placement Communication Date *"
                style="width: 300px"
                v-model="sessionDetails.confirmationDeadline"
                :rules="[checkDate,
                val => checkDateIsBetween(
                  sessionDetails.confirmationDeadline,
                  sessionDetails.applicationDeadline,
                  sessionDetails.moveInDate,
                )
              ||'Placement communication date must be between application deadline and move in date'
                ]"
                lazy-rules
                :borderless="isRa"
                :readonly="isRa"
              >
                <template
                  v-if="!isRa"
                  v-slot:append
                >
                  <q-icon
                    name="event"
                    class="cursor-pointer"
                  >
                    <q-popup-proxy
                      ref="qDateProxy"
                      transition-show="scale"
                      transition-hide="scale"
                    >
                      <q-date
                        v-model="sessionDetails.confirmationDeadline"
                        mask="MM/DD/YYYY"
                      >
                        <div class="row items-center justify-end">
                          <q-btn
                            v-close-popup
                            label="Close"
                            color="primary"
                            flat
                          />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </div>
            <div class="q-gutter-md row items-start">
              <q-checkbox
                v-model="sessionDetails.isOpen"
                label="Session is Currently Open"
                style="width: 300px"
                :true-value="'Open'"
                :false-value="'Closed'"
                :disable="isRa || !sessionDetails.agreementUri"
              />
              <q-input
                label="Student Facing Application Deadline *"
                v-model="sessionDetails.applicationLockDate"
                style="width: 300px"
                :rules="[checkDate]"
                lazy-rules
                :borderless="isRa"
                :readonly="isRa"
              >
                <template
                  v-if="!isRa"
                  v-slot:append
                >
                  <q-icon
                    name="event"
                    class="cursor-pointer"
                  >
                    <q-popup-proxy
                      ref="qDateProxy"
                      transition-show="scale"
                      transition-hide="scale"
                    >
                      <q-date
                        v-model="sessionDetails.applicationLockDate"
                        mask="MM/DD/YYYY"
                      >
                        <div class="row items-center justify-end">
                          <q-btn
                            v-close-popup
                            label="Close"
                            color="primary"
                            flat
                          />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </div>
            <div class="q-gutter-md row items-start">
              <q-input
                label="Payment Deadline"
                style="width: 300px"
                v-model="sessionDetails.paymentDeadline"
                lazy-rules
                :borderless="isRa"
                :readonly="isRa"
              >
                <template
                  v-if="!isRa"
                  v-slot:append
                >
                  <q-icon
                    name="event"
                    class="cursor-pointer"
                  >
                    <q-popup-proxy
                      ref="qDateProxy"
                      transition-show="scale"
                      transition-hide="scale"
                    >
                      <q-date
                        v-model="sessionDetails.paymentDeadline"
                        mask="MM/DD/YYYY"
                      >
                        <div class="row items-center justify-end">
                          <q-btn
                            v-close-popup
                            label="Close"
                            color="primary"
                            flat
                          />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
              <q-input
                label="Paperwork Deadline"
                style="width: 300px"
                v-model="sessionDetails.paperworkDeadline"
                lazy-rules
                :borderless="isRa"
                :readonly="isRa"
              >
                <template
                  v-if="!isRa"
                  v-slot:append
                >
                  <q-icon
                    name="event"
                    class="cursor-pointer"
                  >
                    <q-popup-proxy
                      ref="qDateProxy"
                      transition-show="scale"
                      transition-hide="scale"
                    >
                      <q-date
                        v-model="sessionDetails.paperworkDeadline"
                        mask="MM/DD/YYYY"
                      >
                        <div class="row items-center justify-end">
                          <q-btn
                            v-close-popup
                            label="Close"
                            color="primary"
                            flat
                          />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </div>

            <div class="q-gutter-md row items-start">
              <q-input
                label="Compliance Or Quit Date"
                style="width: 300px"
                v-model="sessionDetails.complianceOrQuitDate"
                lazy-rules
                :borderless="isRa"
                :readonly="isRa"
              >
                <template
                  v-if="!isRa"
                  v-slot:append
                >
                  <q-icon
                    name="event"
                    class="cursor-pointer"
                  >
                    <q-popup-proxy
                      ref="qDateProxy"
                      transition-show="scale"
                      transition-hide="scale"
                    >
                      <q-date
                        v-model="sessionDetails.complianceOrQuitDate"
                        mask="MM/DD/YYYY"
                      >
                        <div class="row items-center justify-end">
                          <q-btn
                            v-close-popup
                            label="Close"
                            color="primary"
                            flat
                          />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
              <q-input
                label="Priority Deadline"
                style="width: 300px"
                v-model="sessionDetails.priorityDeadline"
                lazy-rules
                :borderless="isRa"
                :readonly="isRa"
              >
                <template
                  v-if="!isRa"
                  v-slot:append
                >
                  <q-icon
                    name="event"
                    class="cursor-pointer"
                  >
                    <q-popup-proxy
                      ref="qDateProxy"
                      transition-show="scale"
                      transition-hide="scale"
                    >
                      <q-date
                        v-model="sessionDetails.priorityDeadline"
                        mask="MM/DD/YYYY"
                      >
                        <div class="row items-center justify-end">
                          <q-btn
                            v-close-popup
                            label="Close"
                            color="primary"
                            flat
                          />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </div>

            <div class="q-gutter-md row items-start">
              <q-input
                label="First Year Student Move In Date"
                style="width: 300px"
                v-model="sessionDetails.firstYearStudentMoveInDate"
                lazy-rules
                :borderless="isRa"
                :readonly="isRa"
              >
                <template
                  v-if="!isRa"
                  v-slot:append
                >
                  <q-icon
                    name="event"
                    class="cursor-pointer"
                  >
                    <q-popup-proxy
                      ref="qDateProxy"
                      transition-show="scale"
                      transition-hide="scale"
                    >
                      <q-date
                        v-model="sessionDetails.firstYearStudentMoveInDate"
                        mask="MM/DD/YYYY"
                      >
                        <div class="row items-center justify-end">
                          <q-btn
                            v-close-popup
                            label="Close"
                            color="primary"
                            flat
                          />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
              <q-input
                label="Returning Student Move In Date"
                style="width: 300px"
                v-model="sessionDetails.returningStudentMoveInDate"
                lazy-rules
                :borderless="isRa"
                :readonly="isRa"
              >
                <template
                  v-if="!isRa"
                  v-slot:append
                >
                  <q-icon
                    name="event"
                    class="cursor-pointer"
                  >
                    <q-popup-proxy
                      ref="qDateProxy"
                      transition-show="scale"
                      transition-hide="scale"
                    >
                      <q-date
                        v-model="sessionDetails.returningStudentMoveInDate"
                        mask="MM/DD/YYYY"
                      >
                        <div class="row items-center justify-end">
                          <q-btn
                            v-close-popup
                            label="Close"
                            color="primary"
                            flat
                          />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </div>

            <div class="q-gutter-md row items-start">
              <q-input
                label="Non Continuing Move Out Date"
                style="width: 300px"
                v-model="sessionDetails.nonContinuingMoveOutDate"
                lazy-rules
                :borderless="isRa"
                :readonly="isRa"
              >
                <template
                  v-if="!isRa"
                  v-slot:append
                >
                  <q-icon
                    name="event"
                    class="cursor-pointer"
                  >
                    <q-popup-proxy
                      ref="qDateProxy"
                      transition-show="scale"
                      transition-hide="scale"
                    >
                      <q-date
                        v-model="sessionDetails.nonContinuingMoveOutDate"
                        mask="MM/DD/YYYY"
                      >
                        <div class="row items-center justify-end">
                          <q-btn
                            v-close-popup
                            label="Close"
                            color="primary"
                            flat
                          />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
              <q-input
                label="Continuing Move Out Date"
                style="width: 300px"
                v-model="sessionDetails.continuingMoveOutDate"
                lazy-rules
                :borderless="isRa"
                :readonly="isRa"
              >
                <template
                  v-if="!isRa"
                  v-slot:append
                >
                  <q-icon
                    name="event"
                    class="cursor-pointer"
                  >
                    <q-popup-proxy
                      ref="qDateProxy"
                      transition-show="scale"
                      transition-hide="scale"
                    >
                      <q-date
                        v-model="sessionDetails.continuingMoveOutDate"
                        mask="MM/DD/YYYY"
                      >
                        <div class="row items-center justify-end">
                          <q-btn
                            v-close-popup
                            label="Close"
                            color="primary"
                            flat
                          />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </div>
            <div class="q-gutter-md row items-start">
              <q-input
                label="Priority First Year Confirmation of Space"
                style="width: 300px"
                v-model="sessionDetails.priorityFirstYearConfirmationOfSpace"
                lazy-rules
                :borderless="isRa"
                :readonly="isRa"
              >
                <template
                  v-if="!isRa"
                  v-slot:append
                >
                  <q-icon
                    name="event"
                    class="cursor-pointer"
                  >
                    <q-popup-proxy
                      ref="qDateProxy"
                      transition-show="scale"
                      transition-hide="scale"
                    >
                      <q-date
                        v-model="sessionDetails.priorityFirstYearConfirmationOfSpace"
                        mask="MM/DD/YYYY"
                      >
                        <div class="row items-center justify-end">
                          <q-btn
                            v-close-popup
                            label="Close"
                            color="primary"
                            flat
                          />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
              <q-input
                label="General First Year Confirmation of Space"
                style="width: 300px"
                v-model="sessionDetails.generalFirstYearConfirmationOfSpace"
                lazy-rules
                :borderless="isRa"
                :readonly="isRa"
              >
                <template
                  v-if="!isRa"
                  v-slot:append
                >
                  <q-icon
                    name="event"
                    class="cursor-pointer"
                  >
                    <q-popup-proxy
                      ref="qDateProxy"
                      transition-show="scale"
                      transition-hide="scale"
                    >
                      <q-date
                        v-model="sessionDetails.generalFirstYearConfirmationOfSpace"
                        mask="MM/DD/YYYY"
                      >
                        <div class="row items-center justify-end">
                          <q-btn
                            v-close-popup
                            label="Close"
                            color="primary"
                            flat
                          />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </div>
            <div class="q-gutter-md row items-start">
              <q-input
                label="Cancellation Deposit Refund Deadline"
                style="width: 300px"
                v-model="sessionDetails.cancellationDepositRefundDeadline"
                lazy-rules
                :borderless="isRa"
                :readonly="isRa"
              >
                <template
                  v-if="!isRa"
                  v-slot:append
                >
                  <q-icon
                    name="event"
                    class="cursor-pointer"
                  >
                    <q-popup-proxy
                      ref="qDateProxy"
                      transition-show="scale"
                      transition-hide="scale"
                    >
                      <q-date
                        v-model="sessionDetails.cancellationDepositRefundDeadline"
                        mask="MM/DD/YYYY"
                      >
                        <div class="row items-center justify-end">
                          <q-btn
                            v-close-popup
                            label="Close"
                            color="primary"
                            flat
                          />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </div>
            <div class="q-gutter-md row items-start">
              <q-input
                v-model.trim="sessionDetails.agreementUri"
                label="Agreement URL"
                type="url"
                style="width: 300px"
                :rules="[checkStartsWithHttpsOrEmpty]"
                lazy-rules
                :borderless="isRa"
                :readonly="isRa"
              />
              <q-input
                v-model.number="sessionDetails.depositAmount"
                label="Deposit Amount *"
                style="width: 300px"
                :rules="[checkIsZeroOrLargerInteger]"
                lazy-rules
                :borderless="isRa"
                :readonly="isRa"
              />
            </div>
            <div class="q-gutter-md row items-start">
              <q-input
                v-model.trim="sessionDetails.dssUri"
                label="DSS URL"
                type="url"
                style="width: 300px"
                :rules="[checkStartsWithHttpsOrEmpty]"
                lazy-rules
                :borderless="isRa"
                :readonly="isRa"
              />
              <q-select
                v-model.trim="sessionDetails.sessionTerm"
                style="width: 300px"
                :options="termsOptions"
                use-input
                hide-selected
                fill-input
                input-debounce="0"
                @filter="termsFilter"
                label="Term *"
                :rules="[checkSelect]"
                lazy-rules
              />
              <!-- <q-input
                v-model.number="sessionDetails.vaccinationUri"
                label="Vaccination URL"
                type="url"
                style="width: 300px"
                :rules="[checkStartsWithHttpsOrEmpty]"
                lazy-rules
                :borderless="isRa"
                :readonly="isRa"
              /> -->
            </div>
            <!-- <div class="q-gutter-md row items-start">
              <q-input
                v-model.trim="sessionDetails.llcUri"
                label="LLC URL"
                type="url"
                style="width: 300px"
                :rules="[checkStartsWithHttpsOrEmpty]"
                lazy-rules
                :borderless="isRa"
                :readonly="isRa"
              />
            </div> -->
            <div class="q-gutter-md row items-start">
              <q-select
                v-model="sessionDetails.previousSessionId"
                style="width: 600px"
                :options="sessionNamesOptions"
                emit-value
                map-options
                use-input
                hide-selected
                fill-input
                input-debounce="0"
                label="Previous Session (NOTE: This blocks any previously
                 placed applicants from applying to current session)"
                @filter="sessionNamesFilter"
                clearable
              />
            </div>
            <div v-if="sessionDetails.sessionType === 'Academic'"
              class="q-gutter-md row items-start">
              <q-select
                v-model="sessionDetails.eapSessionId"
                style="width: 600px"
                :options="sessionNamesOptions"
                emit-value
                map-options
                use-input
                hide-selected
                fill-input
                input-debounce="0"
                label="EAP of Current Session"
                @filter="sessionNamesFilter"
                clearable
              />
            </div>
          </fieldset>
          <br>
          <fieldset class="q-gutter-md">
            <legend class="text-left text-h5">
              Whitelist for Post Deadline Applicants
            </legend>
            <q-separator />
            <div class="q-gutter-md row items-start">
              <q-select
                v-model="sessionDetails.postDeadlineApplicantWhitelist"
                style="width: 600px"
                :options="usernameOptions"
                use-input
                use-chips
                multiple
                input-debounce="0"
                label="Select Usernames"
                class="q-mr-xs"
                emit-value
                map-options
                options-cover
                @filter="usernameFilter"
              >
              </q-select>
            </div>
          </fieldset>
          <br />
          <fieldset class="q-gutter-md">
            <legend class="text-left text-h5">
              Email Template Options
            </legend>
            <q-separator />
            <br />
            <div class="q-gutter-md row items-start">
              <q-select
                label="Application Submitted Email Template to Applicant *"
                v-model="sessionDetails.emailTemplateApplicationSubmittedToStudentId"
                :options="emailTemplateNameIdPairs"
                map-options
                emit-value
                option-value="emailTemplateId"
                option-label="emailTemplateName"
                style="width: 600px"
                :borderless="isRa"
                :readonly="isRa"
                :hide-dropdown-icon="isRa"
                dense
                :rules="[checkSelect]"
                lazy-rules
              />
            </div>
            <div class="q-gutter-md row items-start">
              <q-select
                label="Placement Confirmation Email Template to Applicant *"
                v-model="sessionDetails.emailTemplatePlacementCompletedToStudentId"
                :options="emailTemplateNameIdPairs"
                map-options
                emit-value
                option-value="emailTemplateId"
                option-label="emailTemplateName"
                style="width: 600px"
                :borderless="isRa"
                :readonly="isRa"
                :hide-dropdown-icon="isRa"
                dense
                :rules="[checkSelect]"
                lazy-rules
              />
            </div>
            <div class="q-gutter-md row items-start">
              <q-select
                label="DSS Requested Email Template to Applicant *"
                v-model="sessionDetails.emailTemplateDssRequestedToStudentId"
                :options="emailTemplateNameIdPairs"
                map-options
                emit-value
                option-value="emailTemplateId"
                option-label="emailTemplateName"
                style="width: 600px"
                :borderless="isRa"
                :readonly="isRa"
                :hide-dropdown-icon="isRa"
                dense
                :rules="[checkSelect]"
                lazy-rules
              />
            </div>
            <div class="q-gutter-md row items-start">
              <q-select
                label="DSS Requested Email Template to DSS *"
                v-model="sessionDetails.emailTemplateDssRequestedToDssId"
                :options="emailTemplateNameIdPairs"
                map-options
                emit-value
                option-value="emailTemplateId"
                option-label="emailTemplateName"
                style="width: 600px"
                :borderless="isRa"
                :readonly="isRa"
                :hide-dropdown-icon="isRa"
                dense
                :rules="[checkSelect]"
                lazy-rules
              />
            </div>
            <div class="q-gutter-md row items-start">
              <q-select
                label="Application Submitted Email Template To Housing *"
                v-model="sessionDetails.emailTemplateApplicationSubmittedToHousingId"
                :options="emailTemplateNameIdPairs"
                map-options
                emit-value
                option-value="emailTemplateId"
                option-label="emailTemplateName"
                style="width: 600px"
                :borderless="isRa"
                :readonly="isRa"
                :hide-dropdown-icon="isRa"
                dense
                :rules="[checkSelect]"
                lazy-rules
              />
            </div>
          </fieldset>
          <br />
          <fieldset class="q-gutter-md">
            <legend class="text-left text-h5">
              Gender Options
            </legend>
            <q-separator />
            <br />
            <div
              class="text-body1"
              align="left"
            >
              Please map session gender options to colleague gender options below:
            </div>
            <br />
            <div
              class="q-gutter-md row items-start"
              v-for="genderOption, index in sessionDetails.genderOptions"
              :key="index"
            >
              <q-input
                :label="'Housing Display ' + (index + 1) + ' *'"
                v-model.trim="genderOption.sessionOption"
                style="width: 270px"
                :rules="[val => checkHousingGenderDuplicates(val, index),
                checkInput]"
                lazy-rules
                :borderless="isRa"
                :readonly="isRa"
                :hide-dropdown-icon="isRa"
              />
              <q-select
                v-model.trim="genderOption.colleagueOption"
                :label="'Colleague Mapping ' + (index + 1) +' *'"
                :options="colleagueGenderOptions"
                behavior="menu"
                style="width: 270px"
                :rules="[checkSelect]"
                lazy-rules
                :borderless="isRa"
                :readonly="isRa"
                :hide-dropdown-icon="isRa"
              />
              <q-btn
                v-if="sessionDetails.genderOptions.length !== 1 && !isRa"
                @click="removeGenderPair(index)"
                class="q-mt-xl"
                icon="remove"
                color="primary"
                size="xs"
                round
              />
            </div>
            <div class="float-right q-gutter-sm">
              <q-btn
                v-if="!isRa"
                @click="addGenderPair"
                icon="add"
                color="primary"
                size="xs"
                round
              />
            </div>
          </fieldset>
          <br />
          <fieldset class="q-gutter-md">
            <legend class="text-left text-h5">
              Billing Classes
            </legend>
            <q-separator />
            <br />
            <div
              class="text-body1"
              align="left"
            >
              Please select or input billing class options below:
            </div>
            <br />
            <div
              class="q-gutter-md row items-start"
              v-for="unitType, index in sessionDetails.unitTypes"
              :key="index"
            >
              <q-select
                v-model.trim="sessionDetails.unitTypes[index]"
                :label="'Unit Type ' + (index + 1) + ' *'"
                :options="roomRateTablesOptions"
                @filter='roomRateTablesFilter'
                style="max-width: 600px; width: 300px"
                new-value-mode="add-unique"
                :rules="[checkSelect]"
                lazy-rules
                :borderless="isRa"
                :readonly="isRa"
                :hide-dropdown-icon="isRa"
              />
              <q-btn
                v-show="sessionDetails.unitTypes.length !== 1 && !isRa"
                @click="removeUnitType(index)"
                class="q-mt-xl"
                icon="remove"
                color="primary"
                size="xs"
                round
              />
            </div>
            <div class="float-right q-gutter-sm">
              <q-btn
                v-if="!isRa"
                @click="addUnitType"
                icon="add"
                color="primary"
                size="xs"
                round
              />
            </div>
          </fieldset>
          <br />

          <fieldset class="q-gutter-md">
            <legend class="text-left text-h5">
              Description
            </legend>
            <q-separator />
            <br />
            <div class="q-pa-sm">
              <q-editor
                v-model.trim="sessionDetails.description"
                :borderless="isRa"
                :readonly="isRa"
                :dense="$q.screen.lt.md"
                :toolbar="isRa ? '' : [
                  [
                    {
                      icon: $q.iconSet.editor.align,
                      fixedLabel: true,
                      list: 'only-icons',
                      options: ['left', 'center', 'right', 'justify']
                    }
                  ],
                  ['bold', 'italic', 'strike', 'underline', 'subscript', 'superscript'],
                  ['token', 'hr', 'link', 'custom_btn'],
                  ['print', 'fullscreen'],
                  [
                    {
                      icon: $q.iconSet.editor.formatting,
                      fixedLabel: true,
                      fixedIcon: true,
                      list: 'no-icons',
                      options: [
                        'p',
                        'h1',
                        'h2',
                        'h3',
                        'h4',
                        'h5',
                        'h6',
                        'code'
                      ]
                    },
                    {
                      icon: $q.iconSet.editor.fontSize,
                      fixedLabel: true,
                      fixedIcon: true,
                      list: 'no-icons',
                      options: [
                        'size-1',
                        'size-2',
                        'size-3',
                        'size-4',
                        'size-5',
                        'size-6',
                        'size-7'
                      ]
                    },
                    {
                      icon: $q.iconSet.editor.font,
                      fixedLabel: true,
                      fixedIcon: true,
                      list: 'no-icons',
                      options: [
                        'default_font',
                        'arial',
                        'arial_black',
                        'comic_sans',
                        'courier_new',
                        'impact',
                        'lucida_grande',
                        'times_new_roman',
                        'verdana'
                      ]
                    },
                    'removeFormat'
                  ],
                  ['quote', 'unordered', 'ordered', /*'outdent', 'indent'*/],
                  ['undo', 'redo']
                ]"
                :fonts="{
                  arial: 'Arial',
                  arial_black: 'Arial Black',
                  comic_sans: 'Comic Sans MS',
                  courier_new: 'Courier New',
                  impact: 'Impact',
                  lucida_grande: 'Lucida Grande',
                  times_new_roman: 'Times New Roman',
                  verdana: 'Verdana'
                }"
              />
            </div>
          </fieldset>
        </div>
        <div class="row q-ma-lg q-ml-xl">
          <q-uploader
            class="col-11 q-ma-md"
            :url="housingAgreementUploadUrl"
            max-files="1"
            accept=".pdf"
            auto-upload
            @added="clearExistingPdf('housingAgreement')"
            @uploaded="fileUploaded"
          >
            <template v-slot:header="scope">
              <div class="row no-wrap items-center q-pa-sm q-gutter-xs">
                <div class="col">
                  <div class="q-uploader__title">Upload Residence Housing Agreement</div>
                </div>
                <q-btn
                  v-if="!sessionDetails.housingAgreementBlobId"
                  type="a"
                  icon-right="add_box"
                  dense
                  flat
                >
                  <q-uploader-add-trigger style="z-index: 1" />
                  <q-tooltip>Upload residence housing agreement</q-tooltip>
                </q-btn>
                <q-btn
                  v-if="sessionDetails.housingAgreementBlobId || scope.uploadedFiles.length > 0"
                  icon="download"
                  @click="exportPdf(
                  sessionDetails.housingAgreementBlobId,
                  'housingAgreement',
                  sessionDetails.sessionName)"
                  dense
                  flat
                >
                  <q-tooltip>Download housing agreement</q-tooltip>
                </q-btn>
              </div>
            </template>
            <template v-slot:list="scope">
              <q-list separator>

                <q-item
                  v-for="file in scope.files"
                  :key="file.name"
                >
                  <q-item-section>
                    <q-item-label class="full-width ellipsis">
                      {{ file.name }}
                    </q-item-label>

                    <q-item-label caption>
                      Status: {{ file.__status }}
                    </q-item-label>

                    <q-item-label caption>
                      {{ file.__sizeLabel }} / {{ file.__progressLabel }}
                    </q-item-label>
                  </q-item-section>

                  <q-item-section
                    top
                    side
                  >
                    <q-btn
                      class="gt-xs"
                      size="12px"
                      flat
                      dense
                      round
                      icon="clear"
                      @click="deleteBlob(scope, file, 'housingAgreement')"
                    ></q-btn>
                  </q-item-section>
                </q-item>
                <q-item
                  v-for="file in housingAgreementList"
                  :key="file"
                >
                  <q-item-section>
                    <q-item-label class="full-width ellipsis">
                      {{ file }}
                    </q-item-label>

                    <q-item-label caption>
                      Status: uploaded
                    </q-item-label>

                    <!-- <q-item-label caption>
                      {{ file.__sizeLabel }} / {{ file.__progressLabel }}
                    </q-item-label> -->
                  </q-item-section>

                  <q-item-section
                    top
                    side
                  >
                    <q-btn
                      class="gt-xs"
                      size="12px"
                      flat
                      dense
                      round
                      icon="clear"
                      @click="deleteBlob(scope, file, 'housingAgreement')"
                    ></q-btn>
                  </q-item-section>
                </q-item>

              </q-list>
            </template>
          </q-uploader>
          <q-separator />
          <q-uploader
            class="col-11 q-ma-md"
            :url="residenceLifeHandbookUploadUrl"
            max-files="1"
            accept=".pdf"
            max-file-size=20971520
            auto-upload
            @added="clearExistingPdf('residenceLifeHandbook')"
            @uploaded="fileUploaded"
          >
            <template v-slot:header="scope">
              <div class="row no-wrap items-center q-pa-sm q-gutter-xs">
                <div class="col">
                  <div class="q-uploader__title">Upload Residence Life Handbook</div>
                </div>
                <q-btn
                  v-if="!sessionDetails.handbookAgreementBlobId"
                  type="a"
                  icon-right="add_box"
                  dense
                  flat
                >
                  <q-uploader-add-trigger style="z-index: 1" />
                  <q-tooltip>Upload life handbook</q-tooltip>
                </q-btn>
                <q-btn
                  v-if="sessionDetails.handbookAgreementBlobId || scope.uploadedFiles.length > 0"
                  icon="download"
                  @click="exportPdf(
                  sessionDetails.handbookAgreementBlobId,
                  'residenceLifeHandbook',
                  sessionDetails.sessionName)"
                  dense
                  flat
                >
                  <q-tooltip>Download current residence life handbook</q-tooltip>
                </q-btn>
              </div>
            </template>
            <template v-slot:list="scope">
              <q-list separator>

                <q-item
                  v-for="file in scope.files"
                  :key="file.name"
                >
                  <q-item-section>
                    <q-item-label class="full-width ellipsis">
                      {{ file.name }}
                    </q-item-label>

                    <q-item-label caption>
                      Status: {{ file.__status }}
                    </q-item-label>

                    <q-item-label caption>
                      {{ file.__sizeLabel }} / {{ file.__progressLabel }}
                    </q-item-label>
                  </q-item-section>

                  <q-item-section
                    top
                    side
                  >
                    <q-btn
                      class="gt-xs"
                      size="12px"
                      flat
                      dense
                      round
                      icon="clear"
                      @click="deleteBlob(scope, file, 'residenceLifeHandbook')"
                    ></q-btn>
                  </q-item-section>
                </q-item>
                <q-item
                  v-for="file in housingHandbookList"
                  :key="file"
                >
                  <q-item-section>
                    <q-item-label class="full-width ellipsis">
                      {{ file }}
                    </q-item-label>

                    <q-item-label caption>
                      Status: uploaded
                    </q-item-label>

                    <!-- <q-item-label caption>
                      {{ file.__sizeLabel }} / {{ file.__progressLabel }}
                    </q-item-label> -->
                  </q-item-section>

                  <q-item-section
                    top
                    side
                  >
                    <q-btn
                      class="gt-xs"
                      size="12px"
                      flat
                      dense
                      round
                      icon="clear"
                      @click="deleteBlob(scope, file, 'residenceLifeHandbook')"
                    ></q-btn>
                  </q-item-section>
                </q-item>

              </q-list>
            </template>
          </q-uploader>
        </div>
      </q-form>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { date, useQuasar } from 'quasar';
import useAuth from '../../hooks/auth';
import useEmail from '../../hooks/email';
import useUiUtilities from '../../utilities/uiUtilities';
import useUser from '../../hooks/user';
import useUtility from '../../hooks/utility';
import useSession from '../../hooks/session';

export default {
  props: { isCreation: Boolean },
  async setup(props) {
    const $q = useQuasar();
    const { hasRoles } = useAuth();
    const { exportPdf, notifyResult } = useUiUtilities();
    const {
      deleteBlobDocument,
      getBlobDocument,
      getTerms,
      terms,
    } = useUtility();
    const { getEmailTemplateNameIdPairs, emailTemplateNameIdPairs } = useEmail();
    const {
      sessionId,
      sessionDetails,
      colleagueGenderOptions,
      roomRateTables,
      isSessionFormValid,
      fetchSession,
      getGenderIdentities,
      getRoomRateTables,
      getSessionNames,
      sessionNameIds,
    } = useSession();
    const { getAllUsernames } = useUser();

    const genderIdentityResponse = await getGenderIdentities();
    if (genderIdentityResponse.status) {
      notifyResult(genderIdentityResponse.status, genderIdentityResponse);
    }
    getRoomRateTables();
    await getEmailTemplateNameIdPairs();

    const validateForm = ref(null);
    const isRa = !hasRoles('HRL', 'R&D') && hasRoles('RESIDENT-ASSISTANT');
    const housingAgreementUploadUrl = ref('');
    const residenceLifeHandbookUploadUrl = ref('');
    const housingAgreementList = ref();
    const housingHandbookList = ref();

    const onValidate = async () => {
      const result = await validateForm.value.validate();
      if (result) {
        isSessionFormValid.value = true;
      } else {
        isSessionFormValid.value = false;
      }
    };

    const updateBlobUrls = () => {
      const blobUrl = `${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/utility/uploadBlobDocument?`;

      housingAgreementUploadUrl.value = sessionDetails.value.housingAgreementBlobId
        ? `${blobUrl}&blobGeneralId=${sessionDetails.value.housingAgreementBlobId}&blobName=HousingAgreementBlob`
        : `${blobUrl}&blobName=HousingAgreementBlob`;
      residenceLifeHandbookUploadUrl.value = sessionDetails.value.handbookAgreementBlobId
        ? `${blobUrl}&blobGeneralId=${sessionDetails.value.handbookAgreementBlobId}&blobName=HandbookAgreementBlob`
        : `${blobUrl}&blobName=HandbookAgreementBlob`;
    };

    const clearExistingPdf = (category) => {
      if (category === 'housingAgreement') {
        housingAgreementList.value = [];
      }
      if (category === 'residenceLifeHandbook') {
        housingHandbookList.value = [];
      }
    };

    const fileUploaded = ({ xhr }) => {
      const response = JSON.parse(xhr.response);

      if (response.item2 === 'HousingAgreementBlob') {
        sessionDetails.value.housingAgreementBlobId = response.item1;
      } else if (response.item2 === 'HandbookAgreementBlob') {
        sessionDetails.value.handbookAgreementBlobId = response.item1;
      } else {
        console.log('blobName does not match any known blob name');
      }

      updateBlobUrls();
    };

    $q.loading.show();
    const response = await fetchSession(sessionId.value);
    if (response.status) {
      notifyResult(response.status, response);
    }
    $q.loading.hide();

    const deleteBlob = async (scope, file, category = null) => {
      $q.loading.show();
      if (category) {
        clearExistingPdf(category);
      }
      scope.removeFile(file);

      if (category === 'housingAgreement') {
        await deleteBlobDocument(sessionDetails.value.housingAgreementBlobId);
        sessionDetails.value.housingAgreementBlobId = null;
      }
      if (category === 'residenceLifeHandbook') {
        await deleteBlobDocument(sessionDetails.value.handbookAgreementBlobId);
        sessionDetails.value.handbookAgreementBlobId = null;
      }
      $q.loading.hide();
    };

    const addGenderPair = () => {
      sessionDetails.value.genderOptions.push({ sessionOption: '', colleagueOption: '' });
    };

    if (!sessionDetails.value.genderOptions || sessionDetails.value.genderOptions.length === 0) {
      sessionDetails.value.genderOptions = [];
      addGenderPair();
    }

    const removeGenderPair = (index) => {
      if (sessionDetails.value.genderOptions && sessionDetails.value.genderOptions.length > 1) {
        sessionDetails.value.genderOptions.splice(index, 1);
      }
    };

    const addUnitType = () => {
      if (roomRateTables.value.length === 0
        || sessionDetails.value.unitTypes.length < roomRateTables.value.length) {
        sessionDetails.value.unitTypes.push('');
      }
    };

    const removeUnitType = (index) => {
      if (sessionDetails.value.unitTypes && sessionDetails.value.unitTypes.length > 1) {
        sessionDetails.value.unitTypes.splice(index, 1);
      }
    };

    if (!sessionDetails.value.unitTypes || sessionDetails.value.unitTypes.length === 0) {
      sessionDetails.value.unitTypes = [];
      addUnitType();
    }

    const roomRateTablesOptions = ref([]);

    const roomRateTablesFilter = (val, update) => {
      update(() => {
        roomRateTablesOptions.value = roomRateTables.value
          .filter((roomRateClass) => !sessionDetails.value.unitTypes.includes(roomRateClass));
      });
    };

    const sessionTypeList = ['Academic', 'EAP', 'Summer', 'OIP'];

    const checkDate = (val) => date.isValid(val) || 'Invalid date.';
    const checkDateAGreaterThanB = (a, b) => {
      const dateA = new Date(a);
      const dateB = new Date(b);

      return dateA.getTime() > dateB.getTime();
    };
    const checkDateIsBetween = (dateTarget, dateFrom, dateTo) => {
      const target = new Date(dateTarget);
      const from = new Date(dateFrom);
      const to = new Date(dateTo);

      return date.isBetweenDates(target, from, to);
    };
    const checkSelect = (val) => !!val || 'Please select value.';
    const checkInput = (val) => !!val || 'Please enter value.';
    const checkHousingGenderDuplicates = (val, index) => {
      for (let i = 0; i < sessionDetails.value.genderOptions.length; i += 1) {
        if (i !== index) {
          if (val === sessionDetails.value.genderOptions[i].sessionOption) {
            return 'Cannot enter duplicate values.';
          }
        }
      }

      return true;
    };
    const checkSessionNameDuplicates = (val) => {
      if (!props.isCreation) {
        return true;
      }
      for (let i = 0; i < sessionNameIds.value.length; i += 1) {
        if (val.trim() === sessionNameIds.value[i].sessionName.trim()) {
          return 'Cannot use existing session name.';
        }
      }

      return true;
    };

    const checkStartsWithHttps = (val) => {
      const pattern = /^https?:\/\/(.*)$/i;
      return pattern.test(val) || 'Must start with https://';
    };

    const checkStartsWithHttpsOrEmpty = (val) => ((val === '' || !val) ? true : checkStartsWithHttps(val));
    const checkIsZeroOrLargerInteger = (val) => {
      const pattern = /^[0-9]\d*$/i;
      return pattern.test(val) || 'Please enter a number that is 0 or greater.';
    };

    if (props.isCreation) {
      sessionDetails.value.housingAgreementBlobId = null;
      sessionDetails.value.handbookAgreementBlobId = null;
      sessionDetails.value.sessionTerm = null;
      sessionDetails.value.previousSession = null;
    }
    updateBlobUrls();
    housingAgreementList.value = sessionDetails.value.housingAgreementBlobId === null ? [] : [`${sessionDetails.value.sessionName} Housing Agreement.pdf`];
    housingHandbookList.value = sessionDetails.value.handbookAgreementBlobId === null ? [] : [`${sessionDetails.value.sessionName} Residence Life Handbook.pdf`];

    await getTerms();
    const termsList = terms;
    const termsOptions = ref(termsList.value);

    const sessionNames = await getSessionNames();
    if (sessionNames.status) { // only has status if response is error
      notifyResult(sessionNames.status, sessionNames);
    }
    const sessionNamesList = sessionNames.map((x) => ({
      label: x.sessionName,
      value: x.sessionId,
    }));

    const sessionNamesOptions = ref(sessionNamesList);
    const usernameList = await getAllUsernames();

    const usernameOptions = ref(null);
    const usernameFilter = (val, update) => {
      update(() => {
        const needle = val.toLowerCase();
        usernameOptions.value = usernameList.filter(
          (v) => v.toLowerCase().indexOf(needle) > -1,
        );
      });
    };

    return {
      checkSessionNameDuplicates,
      checkDateAGreaterThanB,
      checkDateIsBetween,
      checkIsZeroOrLargerInteger,
      checkStartsWithHttpsOrEmpty,
      clearExistingPdf,
      deleteBlob,
      exportPdf,
      emailTemplateNameIdPairs,
      fileUploaded,
      getBlobDocument,
      housingAgreementList,
      housingAgreementUploadUrl,
      housingHandbookList,
      residenceLifeHandbookUploadUrl,
      isRa,
      sessionId,
      sessionDetails,
      onValidate,
      validateForm,
      checkDate,
      checkSelect,
      checkInput,
      checkHousingGenderDuplicates,
      hasRoles,
      removeGenderPair,
      removeUnitType,
      addGenderPair,
      addUnitType,
      colleagueGenderOptions,
      roomRateTablesOptions,
      roomRateTablesFilter,
      sessionTypeList,
      sessionNamesOptions,
      sessionNamesFilter(val, update) {
        update(() => {
          const needle = val.toLowerCase();
          sessionNamesOptions.value = sessionNamesList.filter(
            (v) => v.label.toLowerCase().indexOf(needle) > -1,
          );
        });
      },
      descriptionEditor: ref(sessionDetails.value.description),
      termsOptions,

      termsFilter(val, update) {
        update(() => {
          const needle = val.toLowerCase();
          termsOptions.value = termsList.value.filter(
            (v) => v.toLowerCase().indexOf(needle) > -1,
          );
        });
      },
      usernameOptions,
      usernameFilter,
    };
  },
};
</script>
